import { render, staticRenderFns } from "./NewAuthority.vue?vue&type=template&id=ff0db97a&scoped=true&"
import script from "./NewAuthority.vue?vue&type=script&lang=js&"
export * from "./NewAuthority.vue?vue&type=script&lang=js&"
import style0 from "./NewAuthority.vue?vue&type=style&index=0&id=ff0db97a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0db97a",
  null
  
)

export default component.exports